module.exports = __webpack_public_path__ + "static/media/arrow-down.c4a22e25.svg";